// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b071d3cf","455":"6515bc70","488":"85cd0ca6","977":"c708dc83"}[chunkId] + ".chunk.js";
};